import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../../directives/directives.module';
import { TimePickerComponent } from './time-picker.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [TimePickerComponent],
  exports: [TimePickerComponent],
  entryComponents: [TimePickerComponent],
  imports: [CommonModule, FormsModule, AngularSvgIconModule, DirectivesModule]
})
export class TimePickerModule {}

export { TimePickerComponent };
